import { render, staticRenderFns } from "./safe-addwwpoint.vue?vue&type=template&id=67314752&scoped=true&"
import script from "./safe-addwwpoint.vue?vue&type=script&lang=js&"
export * from "./safe-addwwpoint.vue?vue&type=script&lang=js&"
import style0 from "./safe-addwwpoint.vue?vue&type=style&index=0&id=67314752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67314752",
  null
  
)

export default component.exports